// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Ld9s8","background__img":"Card_background__img__owUOC"};